import { createFileRoute } from '@tanstack/react-router'

import Modems from 'pages/Modems'

export const Route = createFileRoute('/_auth/_global/modems/')({
  component: Modems,
})
